import GlossOrdering, { OrderMode } from '@/api/graph/GlossOrdering';

export default function (orderBy: GlossOrdering | null): string {
    if (orderBy === null) {
        return '{}';
    }

    const conditions: string[] = [];
    // we assume each prop is of type OrderMode
    for (const [key, value] of Object.entries(orderBy)) {
        conditions.push(`${key}: ${OrderMode[value]}`);
    }

    return `{${conditions.join(', ')}}`;
}
